// TermsAndConditionsPage.js
import React from 'react';
import './WhyPremium.css'

const WhyVihana = () => {
    return (
        <section className='terms-container'>
            <div className='terms-content'>
                <h1>Why We Offer Paid Premium Features</h1>
                <p>At Vihana Matrimony, we’re committed to providing a reliable and effective platform to help you find your perfect match. Here’s why we include paid services in our app:</p>

                <h2>1. Ensuring Quality of Service</h2>
                <ul>
                    <li>Offering premium features allows us to invest in better infrastructure, enhanced security, and dedicated customer support.</li>
                    <li>It enables us to develop advanced features and algorithms that improve your matchmaking experience.</li>
                </ul>

                <h2>2. Encouraging Serious Intentions</h2>
                <ul>
                    <li>Premium services attract users who are genuinely invested in finding a match, fostering a community of serious individuals.</li>
                    <li>It reduces the number of fake or inactive profiles, making your experience more meaningful.</li>
                </ul>

                <h2>3. Supporting Operational Sustainability</h2>
                <ul>
                    <li>Running a high-quality app comes with significant costs, including servers, regular updates, and support teams.</li>
                    <li>Your subscription helps ensure the app remains reliable, secure, and continuously improving.</li>
                </ul>

                <h2>4. Reducing Spam and Fraud</h2>
                <ul>
                    <li>A paid model acts as a natural filter, discouraging those who may misuse the platform.</li>
                    <li>This helps us maintain a safe and trustworthy environment for everyone.</li>
                </ul>

                <h2>5. Offering Enhanced Features</h2>
                <ul>
                    <li>Premium tiers give access to exclusive tools like priority listings, personalized match recommendations, and advanced filters that can significantly improve success rates.</li>
                </ul>

                <h2>6. Protecting Your Data and Privacy</h2>
                <ul>
                    <li>With a subscription-based model, we can prioritize stronger data protection measures, ensuring your personal information remains secure.</li>
                </ul>

                <h2>7. Improving Matchmaking Quality</h2>
                <ul>
                    <li>Revenue from premium services is invested in continuously refining our matching algorithms, so you get the best possible matches.</li>
                </ul>

                <h2>8. Maintaining Safety and Moderation</h2>
                <ul>
                    <li>Paid memberships allow us to fund moderation teams and safety tools, ensuring a secure and respectful community.</li>
                </ul>

                <h2>9. Meeting Legal Standards</h2>
                <ul>
                    <li>Adhering to legal requirements across regions can be expensive, and your support helps us remain compliant while protecting your interests.</li>
                </ul>

                <h2>10. Growing Our Community</h2>
                <ul>
                    <li>Subscription revenue allows us to reach more potential users, increasing the chances of finding your ideal match.</li>
                </ul>

                <h2>11. Personalized Services for Your Journey</h2>
                <ul>
                    <li>Premium memberships often include personalized matchmaking assistance or counseling, giving you tailored support to find the right partner.</li>
                </ul>

                <h2>12. Perception of Value</h2>
                <ul>
                    <li>Paid services are often perceived as more trustworthy and effective, which enhances confidence in the platform.</li>
                </ul>

                <h2>A Balanced Approach</h2>
                <p>While we offer a free version to make our platform accessible, premium features ensure we can deliver the best possible experience. This balance helps us maintain both quality and inclusivity.</p>

                <p>Thank you for choosing Vihana Matrimony to be part of your journey—we’re here to support you every step of the way!</p>
            </div>
        </section>
    );
};

export default WhyVihana;
